<!-- BEGIN AUTH COMPONENT-->
<div class="welcome-body">
  <div class="welcome-container">
    @switch (currentPage()) {
      @case (Page.PHONE_NUMBER) {
        <!-- BEGIN PHONE_NUMBER FORM -->
        <div class="form">
          <!-- BEGIN TAB LINKS -->
          <div class="logo">
            <img src="/assets/images/logo.png" alt="sticky">
            <span class="logo-text">Charge Clean</span>
          </div>
          <div class="subtitle">
            <h2>Login with mobile number</h2>
            <p class="para">
              Please confirm your country code and enter your mobile number
            </p>
          </div>
          <!-- END TAB LINKS -->
          <!-- BEGIN TAB CONTENT -->
          <form (submit)="onSendOtp(loginForm)" #loginForm="ngForm">
            <div class="input-icon">
              <div class="country-code">+91</div>
              <input name="phoneNumber" type="tel" pattern="[0-9]*" ngModel required placeholder="Enter your Mobile Number"
                     #mobileNumberInputLogin="ngModel" maxlength="10">
              @if (mobileNumberInputLogin.invalid && mobileNumberInputLogin.errors?.['maxlength']) {
                <div class="input-error"><span>Please enter a valid phone.</span></div>
              }
            </div>
            <button [disabled]="loginForm.invalid" class="button" type="submit">Send OTP</button>
          </form>
        </div>
        <!-- END PHONE_NUMBER FORM -->
      }
      @case (Page.OTP) {
        <!-- BEGIN OTP FORM -->
        <div class="form">
          <!-- BEGIN TAB LINKS -->
          <div class="logo">
            <img src="/assets/images/logo.png" alt="sticky">
            <span class="logo-text">Charge Clean</span>
          </div>
          <div class="subtitle">
            <h2>OTP Sent</h2>
            <p class="para">
              We have sent OTP to {{phoneNumber()}}
            </p>
          </div>
          <!-- END TAB LINKS -->
          <!-- BEGIN TAB CONTENT -->
          <form (submit)="login(loginForm)" #loginForm="ngForm">
            <!-- BEGIN OTP  BOX -->
            <div class="otp-box">
              <ng-otp-input  (onInputChange)="handleOtpChange($event)" [config]="{ length: 4, allowNumbersOnly: true,    inputStyles: {
                      width: '50px',
                      height: '50px',
                      textAlign: 'center',
                      fontSize: '20px',
                      border: '2px solid #ccc',
                      borderRadius: '8px',
                      outline: 'none',
                      transition: 'all 0.3s ease'
                    }}">
              </ng-otp-input>
            </div>
            <!-- END OTP BOX-->
            <button [disabled]="loginForm.invalid" class="button" type="submit">Verify OTP</button>
          </form>
          <!-- END OTP FORM -->
          <!-- BEGIN OTP RESENT -->
          <div class="otp-resent">
            <div>
              <button class="resent-button" [disabled]="resendOtpTimer() > 0" (click)="resendOtp()">Resend</button> OTP :
              @if (resendOtpTimer()>0) {
                <span class="timer">{{displayResendOtpTimeRemaining()}}</span>
              }
            </div>
          </div>
          <!-- END OTP RESENT -->
        </div>
        <!-- END OTP FORM -->
      }
    }
  </div>
</div>
